import { render } from "./SliderArrows.vue?vue&type=template&id=ee8a9216"
import script from "./SliderArrows.vue?vue&type=script&lang=js"
export * from "./SliderArrows.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__